import {
  fetchExternalAwsAccountById,
  selectExternalAwsAccountById,
  updateExternalAwsAccount,
} from "@app/deploy";
import type { DeployExternalAwsAccount } from "@app/deploy/external-aws-account";
import { useDispatch, useLoader, useQuery, useSelector } from "@app/react";
import { useEffect, useState } from "react";
import { useParams } from "react-router";
import {
  BannerMessages,
  Box,
  BoxGroup,
  Button,
  FormGroup,
  Group,
  Input,
} from "../shared";

interface AccountProps {
  account: DeployExternalAwsAccount;
}

const AccountNameChange = ({ account }: AccountProps) => {
  const dispatch = useDispatch();
  const [accountName, setAccountName] = useState<string>("");

  const action = updateExternalAwsAccount({
    id: account.id,
    accountName,
  });
  const loader = useLoader(action);

  const onSubmitForm = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    dispatch(action);
  };

  useEffect(() => {
    setAccountName(account.accountName);
  }, [account.id]);

  return (
    <form onSubmit={onSubmitForm} className="flex flex-col gap-4">
      <FormGroup label="Account Name" htmlFor="input-name">
        <Input
          name="account-name"
          type="text"
          value={accountName}
          onChange={(e) => setAccountName(e.currentTarget.value)}
          autoComplete="name"
          id="input-name"
        />
      </FormGroup>

      <BannerMessages {...loader} />

      <Group variant="horizontal" size="sm">
        <Button
          className="w-40 semibold"
          type="submit"
          disabled={accountName === account.accountName}
          isLoading={loader.isLoading}
        >
          Save Changes
        </Button>

        <Button
          variant="white"
          onClick={() => setAccountName(account.accountName)}
        >
          Cancel
        </Button>
      </Group>
    </form>
  );
};

export const SettingsAccountIntegrationsAwsSettingsPage = () => {
  const { id = "" } = useParams();
  useQuery(fetchExternalAwsAccountById({ id }));
  const account = useSelector((s) => selectExternalAwsAccountById(s, { id }));

  return (
    <BoxGroup>
      <Box>
        <Group>
          <h3 className={"text-lg text-gray-500"}>Account Settings</h3>
          <AccountNameChange account={account} />
        </Group>
      </Box>
    </BoxGroup>
  );
};
